import { border, inputBackground } from './variables';

// Custom CSS styles for the react-color component
export const colorPickerStyles = {
  default: {
    picker: {
      background: inputBackground,
      boxShadow: "none",
      border: `1px solid ${border}`
    },
  }
};